"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalService = exports.ModalServiceImpl = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var modal_style_1 = require("./modal.style");
var ModalServiceImpl = /** @class */ (function () {
    function ModalServiceImpl() {
        this.CSS = modal_style_1.CSS;
        this.current = null;
        this._bindCtx = null;
    }
    Object.defineProperty(ModalServiceImpl.prototype, "isOpen", {
        get: function () {
            return this.current != null;
        },
        enumerable: false,
        configurable: true
    });
    ModalServiceImpl.prototype.open = function (ctx) {
        var _this = this;
        //We want to make sure the filter is empty when opening a new modal
        services_1.Services.MultiListSearch.reset();
        if (this.isOpen) {
            var currentTitle = '';
            if (this.current != null) {
                currentTitle = this.current.ctx.title;
            }
            this.close(false);
            services_1.Logger.fatal({ newModal: ctx.title, old: currentTitle }, 'Open modal over existing modal');
        }
        this.eventContext.on(this.eventContext.Code.Escape, function () {
            if (ctx.canClose != null && ctx.canClose()) {
                _this.close();
            }
        });
        // tslint:disable:promise-must-complete
        return new Promise(function (resolve, reject) { return _this.current = { resolve: resolve, reject: reject, ctx: ctx }; });
    };
    ModalServiceImpl.prototype.setTitle = function (title) {
        if (this.current == null) {
            services_1.Logger.fatal('ModalService.setTitle called when modal is not open');
            return;
        }
        this.current.ctx.title = title;
    };
    Object.defineProperty(ModalServiceImpl.prototype, "eventContext", {
        get: function () {
            if (this._bindCtx == null) {
                this._bindCtx = services_1.Services.Input.getContext();
            }
            return this._bindCtx;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Force close the current modal.
     *
     * This will resolve the open promise with the same action as "cancel being clicked"
     */
    ModalServiceImpl.prototype.close = function (isOk) {
        if (this.eventContext) {
            this.eventContext.destroy();
        }
        if (!this.isOpen) {
            return null;
        }
        var cancel = isOk == null || isOk === false;
        var ok = !cancel;
        var openPromise = this.current;
        this.current = null;
        openPromise.resolve({ ok: ok, cancel: cancel });
        return false;
    };
    ModalServiceImpl.prototype.view = function () {
        if (!this.isOpen) {
            return null;
        }
        var ctx = this.current.ctx;
        var content;
        if (typeof ctx.content === 'function') {
            content = ctx.content();
        }
        else {
            content = ctx.content;
        }
        var onsubmit = function (e) {
            if (typeof ctx.onSubmit === 'function') {
                ctx.onSubmit();
            }
            e.preventDefault();
            return false;
        };
        return (0, mithril_1.m)('div', { className: modal_style_1.CSS.container + ' ' + modal_style_1.CSS.isOpen }, [
            (0, mithril_1.m)('form', { className: "".concat(modal_style_1.CSS.modal, " ").concat(ctx.className || ''), onsubmit: onsubmit }, [
                (0, mithril_1.m)('div', { className: modal_style_1.CSS.title }, (0, i18n_1.Translate)(ctx.title)),
                (0, mithril_1.m)('div', { className: modal_style_1.CSS.content }, content),
                this.viewActions
            ])
        ]);
    };
    Object.defineProperty(ModalServiceImpl.prototype, "viewActions", {
        get: function () {
            var _this = this;
            var ctx = this.current.ctx;
            if (ctx.actions) {
                return (0, mithril_1.m)('div', { className: modal_style_1.CSS.actions }, typeof (ctx.actions) === 'function' ? ctx.actions() : ctx.actions);
            }
            var onCancelClick = function (_) { return _this.close(false); };
            var onOkClick = function (_) { return _this.close(true); };
            var buttons = [
                (0, mithril_1.m)('button', {
                    className: modal_style_1.MDL.button + ' ' + modal_style_1.CSS.action.ok,
                    onclick: onOkClick,
                    type: 'submit'
                }, (0, i18n_1.Translate)(ctx.okName || i18n_1.T.OK))
            ];
            if (ctx.hasCancel) {
                buttons.unshift((0, mithril_1.m)('button', {
                    className: modal_style_1.MDL.button + ' ' + modal_style_1.CSS.action.cancel,
                    onclick: onCancelClick,
                    type: 'button'
                }, (0, i18n_1.Translate)(i18n_1.T.CANCEL)));
            }
            return (0, mithril_1.m)('div', { className: modal_style_1.CSS.actions }, buttons);
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], ModalServiceImpl.prototype, "current", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], ModalServiceImpl.prototype, "isOpen", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalServiceImpl.prototype, "open", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalServiceImpl.prototype, "setTitle", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalServiceImpl.prototype, "close", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], ModalServiceImpl.prototype, "viewActions", null);
    return ModalServiceImpl;
}());
exports.ModalServiceImpl = ModalServiceImpl;
exports.ModalService = new ModalServiceImpl();
//# sourceMappingURL=modal.service.js.map